<template>
  <div class="relation">
    <div class="banner">
      <img src="@/assets/relation/relationus.png">
    </div>
    <el-row class="information inner">
      <el-col :span="12">
        <div class="bg-purple">
          <p>郑州沐之盛信息科技有限公司</p>
          <p class="txt">地址</p>
          <p>河南省郑州市金水区锦艺金水湾观 澜苑底层商铺14#3</p>
          <p class="txt">网址</p>
          <p>http://xhm2006.com/</p>
          <p class="txt">电话</p>
          <p>13838272674</p>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="bg-purple-light">
          <baidu-map :zoom="12" class="map" @ready="handler">
            <el-button class="button" circle icon="el-icon-zoom-in" @click="setScreenfull" />
            <!-- 控件将定位到地图的右上角 -->
            <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT" />
            <!-- 平移缩放组件 -->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
            <!-- 缩略图 -->
            <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :is-open="true" />
            <!-- 定位 -->
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_LEFT" :show-address-bar="true" :auto-location="true" />
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
            <!-- 示例位置 -->
          </baidu-map>
        </div>
      </el-col>
    </el-row>
    <div class="underneath">
      <div class="inner">
        <h2>各事业部联系方式</h2>
        <p class="txt">我们专心、细心地位每位客户提供更好的服务，用专业与勤劳为一个个客户带去了品牌的传播，销量的提升。企业所需要的不是今天销量，而是持续性的品牌竞争力。</p>
        <ul>
          <li v-for="item in underneathList" :key="item.id">
            <p class="caption">{{item.tit}}</p>
            <div class="relation">
              <div class="relationCon">
                <p>{{item.relation}}</p>
                <p>{{item.phone}}</p>
              </div>
              <img :src="item.url" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/relation.css'
import '@/css/public.css'

import screenfull from 'screenfull'
import BaiduMap from 'vue-baidu-map'
import Vue from 'vue'
Vue.use(BaiduMap, {
  ak: 'lflYKxaHWs6Pha0UmrKsNrlRQypMgEhC'
})

export default {
  data() {
    return {
      underneathList: [
        {
          id: 1, url: require("@/assets/wt.jpg"), tit: '租赁及解决方案事业部', relation: '负责人：王彤',
          phone: '联系电话：18738172557'
        },
        {
          id: 2, url: require("@/assets/sfx.jpg"), tit: '共享/无人自助文印项目部', relation: '负责人：孙付新',
          phone: '联系电话：13838272674'
        }
      ],
    }
  },
  methods: {
    setScreenfull() {
      const element = document.querySelector('.map')
      if (!screenfull.isEnabled) {
        // 如果不允许进入全屏，发出不允许提示
        this.$message({
          message: '暂不不支持全屏',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle(element)
    },
    // 百度地图
    handler({ BMap, map
    }) {
      map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
      this.pt = new BMap.Point(113.66411342164614, 34.85531183981462)
      var point = new BMap.Point(113.66411342164614, 34.85531183981462)
      map.centerAndZoom(point, 12)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
    }
  }
}
</script>
